import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetLearnosityExamTestSessions, useGetTestlets } from '../hooks';
import BreadcumbsFilter from '@containers/BreadcumbsFilter';

const TestBreadcrumbsFilter = ({ currentPage }: { currentPage: string }) => {
  const { testSessionId, testletId } = useParams();
  const { data: testSessions } = useGetLearnosityExamTestSessions();
  const sessionId = useMemo(
    () => (testSessionId ? parseInt(testSessionId, 10) : testSessions?.[0]?.id),
    [testSessionId, testSessions],
  );
  const { data: testlets } = useGetTestlets(sessionId ?? 0);

  // Memoize test session name
  const testSessionName = useMemo(() => {
    if (sessionId && testSessions) {
      const session = testSessions.find((s) => s.id === sessionId);
      if (session) {
        return `Practice Test ${session.practice_test_order + 1}`;
      }
    }
    return '';
  }, [sessionId, testSessions]);

  // Memoize testlet name
  const testletName = useMemo(() => {
    if (testletId && testlets) {
      const testlet = testlets.find((t) => t.id === parseInt(testletId, 10));
      if (testlet) {
        return testlet.name;
      }
    }
    return '';
  }, [testletId, testlets]);

  // Memoize breadcrumb list
  const breadcumbList = useMemo(() => {
    const list = ['Tests'];
    // Add each navigation level if it exists
    if (testSessionName) {
      list.push(testSessionName);
    }
    if (testletName) {
      list.push(testletName);
    }
    if (currentPage) {
      list.push(currentPage);
    }
    return list;
  }, [testSessionName, testletName, currentPage]);

  return <BreadcumbsFilter breadcumbList={breadcumbList} mobileTitle="Tests" />;
};

export default TestBreadcrumbsFilter;
